import styled from "styled-components";

export const Carousel = styled.div`
    margin-top: 24px;
    display: flex;
    align-items: center;
    overflow: auto;
    padding-bottom: 25px;
    height: 218px;
    &::-webkit-scrollbar {    
        display: none;
    }
`;